import gql from 'graphql-tag';

const PURCHASE_ORDER_DETAIL_FRAGMENT = gql`
	fragment purchaseOrder on PurchaseOrder {
		id
		identifier
		created
		status
		notDeliveredItemCount
		percentageComplete
			source {
				id
				name
				productOrderConstraints
				minOrderQuantity
				orderStepQuantity
				orderQuantityUnit
				products {
					id
					name
				imageUrl
			}
		}
		destination {
			id
			name
		}
		items {
			id
			quantity
			originalQuantity
			notDeliveredAt
			deliveryOutcome
			notDeliveredBy {
				id
				firstname
				lastname
			}
			stockDeliveryItem {
				id
				deliveredAt
				receivedAt
				expiryCaptureRequired
				expiryPolicyContext
				stockDelivery {
					id
					identifier
					sourceObj
					status
				}
			}
			warehouseProduct {
				id
				quantity
				defaultOrderQuantity
				pickOrder
				product {
					id
					name
					imageUrl
					measurementUnit
					caseSize
					shipperSize
					palletSize
					forceQuantityInUnits
				}
			}
		}
	}
`;

export const GET_PURCHASE_ORDER = gql`
	query($id: String) {
		getPurchaseOrder (id: $id) {
			...purchaseOrder
		}
	}
	${PURCHASE_ORDER_DETAIL_FRAGMENT}
`;





const PURCHASE_ORDER_LIST_FRAGMENT = gql`
	fragment purchaseOrderList on PurchaseOrder {
		id
		identifier
		created
		status
		notDeliveredItemCount
		source {
			id
			name
			products {
				id
			}
		}
		destination {
			id
			name
		}
		percentageComplete
	}
`;

export const GET_PURCHASE_ORDER_LIST = gql`
	query getPurchaseOrders(
		$page: Int!,
		$perPage: Int!,
		$sortBy: String!,
		$sortDirection: Int!,
		$filter: PurchaseOrderPageFilter,
	) {
		getPurchaseOrders(
			page: $page,
			perPage: $perPage,
			sortBy: $sortBy,
			sortDirection: $sortDirection,
			filter: $filter
		) {
			items {
				...purchaseOrderList
			}
			count
		}
	}
	${PURCHASE_ORDER_LIST_FRAGMENT}
`;

export const GET_PURCHASE_ORDERS_COUNT = gql`
	query (
		$filter: PurchaseOrderCountFilter
	) {
		countPurchaseOrders(
			filter: $filter,
		)
	}
`;
